import React, { useEffect, useState } from "react";
import axios from "axios";

const HuellasLector = () => {
  // ==============================
  // ESTADOS
  // ==============================

  const fechaHoy = new Date().toLocaleDateString("en-CA");

  const [fechaDesde, setFechaDesde] = useState(fechaHoy);
  const [fechaHasta, setFechaHasta] = useState(fechaHoy);

  const [usuario, setUsuario] = useState("");
  const [sede, setSede] = useState("");
  const [ipLector, setIpLector] = useState("");
  const [estado, setEstado] = useState("");

  const [huellas, setHuellas] = useState([]);

  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");

  // ==============================
  // CONSULTAR HUELLAS
  // ==============================

  const obtenerHuellas = async () => {
    try {
      setCargando(true);
      setError("");

      const params = {};

      if (fechaDesde) {
        params.fecha_desde = fechaDesde;
      }

      if (fechaHasta) {
        params.fecha_hasta = fechaHasta;
      }

      if (usuario.trim() !== "") {
        params.usuario = usuario.trim();
      }

      if (sede !== "") {
        params.sede = sede;
      }

      if (ipLector.trim() !== "") {
        params.ip_lector = ipLector.trim();
      }

      if (estado !== "") {
        params.estado = estado;
      }

      const response = await axios.post(
        "https://wwwp.isepsantafe.net.ar/lector-huella/trae-huellas",
        null,
        {
          params: params,
        }
      );

      setHuellas(response.data);

    } catch (err) {
      console.error("Error obteniendo huellas:", err);

      setError(
        err.response?.data?.detail ||
        "No se pudieron obtener los registros."
      );

      setHuellas([]);

    } finally {
      setCargando(false);
    }
  };

  // ==============================
  // CARGAR AL ENTRAR
  // ==============================

  useEffect(() => {
    obtenerHuellas();
  }, []);

  // ==============================
  // LIMPIAR FILTROS
  // ==============================

  const limpiarFiltros = () => {
    setFechaDesde(fechaHoy);
    setFechaHasta(fechaHoy);
    setUsuario("");
    setSede("");
    setIpLector("");
    setEstado("");
  };

  // ==============================
  // FORMATEAR HORA
  // ==============================

  const formatearHora = (hora) => {
    if (!hora) return "-";

    return hora.substring(0, 8);
  };

  // ==============================
  // FORMATEAR FECHA
  // ==============================

  const formatearFecha = (fecha) => {
    if (!fecha) return "-";

    const partes = fecha.split("-");

    if (partes.length !== 3) {
      return fecha;
    }

    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };

  return (
    <div
      style={{
        width: "95%",
        maxWidth: "1400px",
        margin: "25px auto",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.12)",
        padding: "20px",
      }}
    >

      {/* ========================================= */}
      {/* TITULO */}
      {/* ========================================= */}

      <div
        style={{
          background: "#456",
          color: "white",
          padding: "15px",
          borderRadius: "8px",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <h3 style={{ margin: 0 }}>
          🖐️ Registros de Huellas
        </h3>

        <small>
          Consulta de registros enviados por los lectores biométricos
        </small>
      </div>

      {/* ========================================= */}
      {/* FILTROS */}
      {/* ========================================= */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: "12px",
          marginBottom: "20px",
        }}
      >

        {/* FECHA DESDE */}

        <div>
          <label style={{ fontWeight: "bold" }}>
            Fecha desde
          </label>

          <input
            type="date"
            value={fechaDesde}
            onChange={(e) => setFechaDesde(e.target.value)}
            className="form-control"
          />
        </div>

        {/* FECHA HASTA */}

        <div>
          <label style={{ fontWeight: "bold" }}>
            Fecha hasta
          </label>

          <input
            type="date"
            value={fechaHasta}
            onChange={(e) => setFechaHasta(e.target.value)}
            className="form-control"
          />
        </div>

        {/* USUARIO */}

        <div>
          <label style={{ fontWeight: "bold" }}>
            Usuario / DNI
          </label>

          <input
            type="text"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            placeholder="Ej: 36860924"
            className="form-control"
          />
        </div>

        {/* SEDE */}

        <div>
          <label style={{ fontWeight: "bold" }}>
            Sede
          </label>

          <select
            value={sede}
            onChange={(e) => setSede(e.target.value)}
            className="form-control"
          >
            <option value="">
              Todas
            </option>

            <option value="Rosario">
              Rosario
            </option>

            <option value="Recreo">
              Recreo
            </option>
          </select>
        </div>

        {/* IP */}

        <div>
          <label style={{ fontWeight: "bold" }}>
            IP del lector
          </label>

          <input
            type="text"
            value={ipLector}
            onChange={(e) => setIpLector(e.target.value)}
            placeholder="Ej: 192.168.1.100"
            className="form-control"
          />
        </div>

        {/* ESTADO */}

        <div>
          <label style={{ fontWeight: "bold" }}>
            Estado
          </label>

          <select
            value={estado}
            onChange={(e) => setEstado(e.target.value)}
            className="form-control"
          >
            <option value="">
              Todos
            </option>

            <option value="Activo">
              Activo
            </option>

            <option value="Desactivado">
              Desactivado
            </option>
          </select>
        </div>

      </div>

      {/* ========================================= */}
      {/* BOTONES */}
      {/* ========================================= */}

      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          marginBottom: "20px",
        }}
      >

        <button
          className="btn btn-primary"
          onClick={obtenerHuellas}
          disabled={cargando}
        >
          {cargando ? "Buscando..." : "🔎 Buscar"}
        </button>

        <button
          className="btn btn-secondary"
          onClick={() => {
            limpiarFiltros();
          }}
        >
          🧹 Limpiar filtros
        </button>

      </div>

      {/* ========================================= */}
      {/* ERROR */}
      {/* ========================================= */}

      {error && (
        <div className="alert alert-danger">
          ❌ {error}
        </div>
      )}

      {/* ========================================= */}
      {/* RESUMEN */}
      {/* ========================================= */}

      <div
        style={{
          backgroundColor: "#f1f5f9",
          borderRadius: "8px",
          padding: "12px",
          marginBottom: "15px",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >

        <strong>
          📊 Registros encontrados:
        </strong>

        <span
          style={{
            backgroundColor: "#456",
            color: "white",
            padding: "5px 12px",
            borderRadius: "20px",
            fontWeight: "bold",
          }}
        >
          {huellas.length}
        </span>

      </div>

      {/* ========================================= */}
      {/* CARGANDO */}
      {/* ========================================= */}

      {cargando && (
        <div
          style={{
            textAlign: "center",
            padding: "30px",
          }}
        >
          <div
            className="spinner-border"
            role="status"
          >
          </div>

          <div style={{ marginTop: "10px" }}>
            Consultando registros...
          </div>
        </div>
      )}

      {/* ========================================= */}
      {/* TABLA */}
      {/* ========================================= */}

      {!cargando && (
        <div
          style={{
            overflowX: "auto",
          }}
        >

          <table
            className="table table-hover table-bordered"
            style={{
              verticalAlign: "middle",
              textAlign: "center",
            }}
          >

            <thead
              style={{
                backgroundColor: "#456",
                color: "white",
              }}
            >
              <tr>

                <th>ID</th>

                <th>Usuario</th>

                <th>Fecha</th>

                <th>Hora</th>

                <th>Sede</th>

                <th>Operación</th>

                <th>IP Lector</th>

                <th>Estado</th>

              </tr>
            </thead>

            <tbody>

              {huellas.length === 0 && (
                <tr>
                  <td
                    colSpan="8"
                    style={{
                      padding: "30px",
                      color: "#777",
                    }}
                  >
                    No se encontraron registros.
                  </td>
                </tr>
              )}

              {huellas.map((huella) => (
                <tr key={huella.id}>

                  <td>
                    {huella.id}
                  </td>

                  <td>
                    <strong>
                      {huella.usuario}
                    </strong>
                  </td>

                  <td>
                    {formatearFecha(huella.fecha)}
                  </td>

                  <td>
                    <span
                      style={{
                        backgroundColor: "#e8f4ff",
                        padding: "5px 10px",
                        borderRadius: "6px",
                        fontWeight: "bold",
                      }}
                    >
                      {formatearHora(huella.hora)}
                    </span>
                  </td>

                  <td>
                    {huella.sede || "-"}
                  </td>

                  <td>
                    {huella.operacion || "-"}
                  </td>

                  <td>
                    {huella.ip_lector || "-"}
                  </td>

                  <td>

                    {huella.estado === "Activo" ? (

                      <span
                        className="badge bg-success"
                      >
                        Activo
                      </span>

                    ) : (

                      <span
                        className="badge bg-secondary"
                      >
                        {huella.estado || "-"}
                      </span>

                    )}

                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>
      )}

    </div>
  );
};

export default HuellasLector;